import ModelUtil from '@leverege/model-util';
import { AggModelFactory } from "../types/index.js";
const TYPE = 'aggregation.AggregationListModel';
function create() {
  return {
    type: TYPE,
    aggregations: [],
    options: {
      variant: null,
      includePageFilters: false
    }
  };
}
function toImagineAgg(model, context) {
  if (model.aggregations.length === 0) {
    return null;
  }
  return model.aggregations.reduce((prev, curr) => {
    const model = AggModelFactory.get(curr.model);
    const agg = model.toImagineAgg(curr.model, context);
    // eslint-disable-next-line no-param-reassign
    if (agg) {
      prev[curr.id] = agg;
    }
    return prev;
  }, {});
}
export default {
  create,
  TYPE,
  toImagineAgg,
  ...ModelUtil.createAllArray('aggregations'),
  ...ModelUtil.createAllValue('options/variant', 'variant', 'Variant'),
  ...ModelUtil.createAllValue('options/includePageFilters', 'includePageFilters')
};